import {
  MESSAGE_VARIANTS,
  SENDER_TYPES,
} from 'dashboard/components-next/message/constants';

// Who is speaking, in the kit's words (round 1 record): the customer is
// `customer`, a human agent `agent` (carbon), Polaris AI `ai` (its gradient),
// a private note `note` (amber), a failure `failed`. The kit has no bubble for
// other automations, so agent bots and templates take `teammate` — the violet
// the old screen already gave them.
const BY_VARIANT = {
  [MESSAGE_VARIANTS.USER]: 'customer',
  [MESSAGE_VARIANTS.AGENT]: 'agent',
  [MESSAGE_VARIANTS.PRIVATE]: 'note',
  [MESSAGE_VARIANTS.ERROR]: 'failed',
  [MESSAGE_VARIANTS.BOT]: 'teammate',
  [MESSAGE_VARIANTS.TEMPLATE]: 'teammate',
  [MESSAGE_VARIANTS.UNSUPPORTED]: 'outline',
};

/**
 * The Polaris bubble variant for a message of the conversation.
 *
 * @param {{ variant: string, senderType?: string|null }} message
 * @returns {string|null} a `bubbleVariants` variant, or null when the message
 *   is not drawn as a bubble (email, activity) and keeps its own component.
 */
export function polarisBubbleVariant({ variant, senderType = null }) {
  if (
    variant === MESSAGE_VARIANTS.AGENT &&
    senderType === SENDER_TYPES.POLARIS_ASSISTANT
  ) {
    return 'ai';
  }

  return BY_VARIANT[variant] ?? null;
}
